export const USER_LANGUAGES = ['en', 'fr', 'it']
